import { useMemo } from 'react';
import { maxClicksCouponFiltering } from './max-clicks-coupon-filtering';
import { maxConversionsCouponFiltering } from './max-conversions-coupon-filtering';
import { AUTO_BIDDING_FEATURE_IDS } from '../../constants';

const featureIdToCampaignFiltering = Object.freeze({
  [AUTO_BIDDING_FEATURE_IDS.MAX_CLICKS]: maxClicksCouponFiltering,
  [AUTO_BIDDING_FEATURE_IDS.MAX_CONVERSIONS]: maxConversionsCouponFiltering,
});

const search = searchQuery => `contains(Name, '${searchQuery.toString().toLowerCase()}')`;

const and = (...filters) => `${filters.map(filter => `(${filter})`).join(' and ')}`;

const or = (...filters) => `${filters.map(filter => `(${filter})`).join(' or ')}`;

const setFilter = filterString => `$filter=(${filterString})`;

const toQueryString = filterString => encodeURI(setFilter(filterString));

const selectCampaignsIds = ids => `${ids.map(id => `Id eq ${id}`).join(' or ')}`;

export const useCampaignFiltering = (coupon) => {
  const campaignFiltering = useMemo(() => featureIdToCampaignFiltering[coupon.FeatureId] || {}, [coupon.FeatureId]);

  return {
    campaignTypeFiltering: campaignFiltering.campaignTypeFiltering,
    biddingStrategyTypeFiltering: campaignFiltering.biddingStrategyTypeFiltering,
    search,
    and,
    or,
    setFilter,
    toQueryString,
    selectCampaignsIds,
  };
};
